import React, { useEffect, useState } from "react";
import NumericFormat from "../../../NumericFormat";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import { useQuoteItem, ACTIONS } from "../../../../providers/quoteItemProvider";
import { utils } from "../../../../utils/utils";
import InformationModal from "../../../InformationModal";
import QuoteItemEditOptionsModal from "./QuoteItemEditOptionsModal";
import { useJobDetails } from "../../../../providers/jobDetailsProvider";

const QuoteItemSubcontractorRoles = ({
  quoteItemSubcontractorRoles,
  setQuoteItemSubcontractorRoles,
}) => {
  const [quoteItemContext, setQuoteItemContext] = useQuoteItem();
  const [jobDetails] = useJobDetails();

  const isJobLocked = jobDetails.job.lockDate;

  const [editOptionsModal, setEditOptionsModal] = useState();
  const [totalCost, setTotalCost] = useState();

  const [informationModal, setInformationModal] = useState({
    isOpen: false,
    title: "",
    body: "",
    onClose: null,
  });

  useEffect(() => {
    const quoteItemSubcontractorRoles =
      quoteItemContext.quoteItem.quoteItemSubcontractorRoles.reduce((p, c) => {
        p[c.id] = c;
        return p;
      }, {});
    setQuoteItemSubcontractorRoles(quoteItemSubcontractorRoles);
  }, [quoteItemContext.quoteItem, setQuoteItemSubcontractorRoles]);

  useEffect(() => {
    const totalCost = Object.values(quoteItemSubcontractorRoles).reduce(
      (p, c) => p + parseFloat(c.cost || 0),
      0
    );
    setTotalCost(totalCost);
  }, [quoteItemSubcontractorRoles]);

  const onFieldChange = (subcontractorRoleId, field, value) =>
    setQuoteItemSubcontractorRoles({
      ...quoteItemSubcontractorRoles,
      [subcontractorRoleId]: {
        ...quoteItemSubcontractorRoles[subcontractorRoleId],
        [field]: value || 0,
      },
    });

  return (
    <ListGroup>
      <ListGroupItem className="border-radius-0 d-flex justify-content-between align-items-center bg-lighter">
        <small className="font-weight-bold text-muted">
          Subcontractor Roles
        </small>
        {isJobLocked ? null : (
          <div className="d-flex">
            <Button
              className="rounded"
              size="sm"
              onClick={() => setEditOptionsModal(true)}
            >
              Edit Options
            </Button>
          </div>
        )}
      </ListGroupItem>
      {quoteItemContext.quoteItem.quoteItemSubcontractorRoles
        .sort((x, y) =>
          x.subcontractorRole.order < y.subcontractorRole.order ? -1 : 1
        )
        .map((subcontractorRole) => {
          const cost =
            quoteItemSubcontractorRoles[subcontractorRole.id]?.cost || "";
          return (
            <ListGroupItem
              key={subcontractorRole.id}
              className="border-radius-0 d-flex justify-content-between align-items-center py-0"
            >
              <span>{subcontractorRole.subcontractorRole.name}</span>
              <div className="width-150">
                <NumericFormat
                  required={true}
                  readOnly={isJobLocked}
                  maxLength={20}
                  allowNegative={false}
                  decimalScale={2}
                  className="form-control border text-right m-1"
                  value={cost}
                  placeholder={"Enter cost..."}
                  thousandSeparator={true}
                  prefix={"$"}
                  onFocus={() => {
                    const currentCost =
                      quoteItemSubcontractorRoles[subcontractorRole.id]?.cost;
                    if (!currentCost) {
                      onFieldChange(subcontractorRole.id, "cost", 0);
                    }
                  }}
                  onValueChange={(e) =>
                    onFieldChange(subcontractorRole.id, "cost", e.value)
                  }
                />
              </div>
            </ListGroupItem>
          );
        })}
      <ListGroupItem className="d-flex flex-column py-0">
        <div className="border-radius-0 d-flex justify-content-between align-items-center ">
          <span className="font-weight-bold">Total Cost</span>
          <div className="width-150">
            <div readOnly className="form-control border text-right m-1">
              {utils.formatCurrency(totalCost)}
            </div>
          </div>
        </div>
      </ListGroupItem>
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() =>
            informationModal.onClose
              ? informationModal.onClose()
              : setInformationModal({ isOpen: false, title: "", body: "" })
          }
        />
      ) : editOptionsModal ? (
        <QuoteItemEditOptionsModal
          title="Subcontractor Roles"
          field="quoteItemSubcontractorRoles"
          idField="subcontractorRoleId"
          quoteItem={quoteItemContext.quoteItem}
          onSubmit={() => {
            setEditOptionsModal(false);
            setQuoteItemContext({
              action: ACTIONS.REFRESH,
            });
          }}
          onClose={() => setEditOptionsModal(false)}
        />
      ) : null}
    </ListGroup>
  );
};

export default QuoteItemSubcontractorRoles;
